module.exports = __webpack_public_path__ + "static/assets/7387ae244b855eec25993a1b5e8805b1.png";